class Role {
} 
// User related permissions
Role.USER_MANAGEMENT_READ = 'USER_MANAGEMENT_READ';
Role.USER_MANAGEMENT_WRITE = 'USER_MANAGEMENT_WRITE';
// Developer user management permissions
Role.DEVELOPER_USER_MANAGEMENT_READ = 'DEVELOPER_USER_MANAGEMENT_READ';
Role.DEVELOPER_USER_MANAGEMENT_WRITE = 'DEVELOPER_USER_MANAGEMENT_WRITE';
Role.DEVELOPER_SELF_USER_MANAGEMENT_WRITE = 'DEVELOPER_SELF_USER_MANAGEMENT_WRITE';
Role.DEVELOPER_SELF_USER_MANAGEMENT_READ = 'DEVELOPER_SELF_USER_MANAGEMENT_READ';
// Indirect user management permissions
Role.INDIRECT_LIQUIDITY_USER_MANAGEMENT_WRITE = 'INDIRECT_LIQUIDITY_USER_MANAGEMENT_WRITE';
// Internal client related permissions
Role.INTERNAL_USER_MANAGEMENT_READ = 'INTERNAL_USER_MANAGEMENT_READ';
Role.INTERNAL_USER_MANAGEMENT_WRITE = 'INTERNAL_USER_MANAGEMENT_WRITE';
Role.INTERNAL_QUALIFICATION_WRITE = 'INTERNAL_QUALIFICATION_WRITE';
// My endpoint related permissions
Role.SELF_USER_MANAGEMENT_READ = 'SELF_USER_MANAGEMENT_READ';
Role.SELF_USER_MANAGEMENT_WRITE = 'SELF_USER_MANAGEMENT_WRITE';
Role.VERIFY_TIMED_OTP = 'VERIFY_TIMED_OTP';
// Cefi yield role
// This role is not assigned to any groups by default. It is potentially assigned
// as part of the cefi qualifications process.
Role.CEFI_YIELD_ROLE = 'CEFI_YIELD_ROLE';
Role.CEFI_YIELD_READ_ROLE = 'CEFI_YIELD_READ_ROLE';
// Usdc Rewards role
// This role is not assigned to any groups by default. It is potentially assigned
// as part of the usdc rewards qualifications process.
Role.USDC_REWARDS_ROLE = 'USDC_REWARDS_ROLE';
Role.USDC_REWARDS_READ_ROLE = 'USDC_REWARDS_READ_ROLE';
// Account Dashboard Management Worker
Role.ACCOUNT_DASHBOARD_MANAGEMENT_ROLE = 'ACCOUNT_DASHBOARD_MANAGEMENT_ROLE';
Role.ACCOUNT_DASHBOARD_MANAGEMENT_READ_ROLE = 'ACCOUNT_DASHBOARD_MANAGEMENT_READ_ROLE';
// Billing Dashboard Role For Circle Accounts
Role.BILLING_DASHBOARD_ROLE = 'BILLING_DASHBOARD_ROLE';
Role.BILLING_DASHBOARD_READ_ROLE = 'BILLING_DASHBOARD_READ_ROLE';
// role to enable the sandbox experience in the Circle Account Dashboard
Role.SANDBOX_USER_ROLE = 'SANDBOX_USER_ROLE';
Role.SANDBOX_USER_READ_ROLE = 'SANDBOX_USER_READ_ROLE';
// Developer Role for Circle Accounts
// primarily for sandbox & developer users
// Confluence page for details: https://circlepay.atlassian.net/wiki/x/0wBwHg
// role to view/edit all features within the Developer tab
Role.DEVELOPER_ROLE = 'DEVELOPER_ROLE';
// role to view features within the Developer tab
Role.DEVELOPER_READ_ROLE = 'DEVELOPER_READ_ROLE';
// Fiat related roles
// primarily for sandbox users
Role.PAYMENT_INTENTS_ROLE = 'PAYMENT_INTENTS_ROLE';
Role.CHECKOUT_WIDGET_ROLE = 'CHECKOUT_WIDGET_ROLE';
Role.CHECKOUT_WIDGET_READ_ROLE = 'CHECKOUT_WIDGET_READ_ROLE';
// Vault role
// This role isn't assigned by default. It is potentially assigned
// as part of the vault qualifications process
Role.VAULT_MANAGEMENT_ROLE = 'VAULT_MANAGEMENT_ROLE';
Role.VAULT_MANAGEMENT_READ_ROLE = 'VAULT_MANAGEMENT_READ_ROLE';
// SSO_ENABLED role
// A synthetic role to give appropriate permissions to users enabled with SSO
Role.SSO_ENABLED_ROLE = 'SSO_ENABLED_ROLE';
// LIMITED_CA read role
// This role doesn't have actual circle permissions associated, used by account-web to indicate user who is in limited ca onboarding flow
Role.LIMITED_CA_READ_ROLE = 'LIMITED_CA_READ_ROLE';
// VERIFY_MFA role
// This role allows user for timed one-time-password verification
Role.VERIFY_MFA_ROLE = 'VERIFY_MFA_ROLE';
// Pii roles
Role.INDIRECT_USER_PII_READ = 'INDIRECT_USER_PII_READ';
// DevEx roles
Role.DEVELOPER_BILLING_ROLE = 'DEVELOPER_BILLING_ROLE';
Role.DEVELOPER_SELF_USER_MANAGEMENT_ROLE = 'DEVELOPER_SELF_USER_MANAGEMENT_ROLE';
Role.DEVELOPER_USER_MANAGEMENT_ROLE = 'DEVELOPER_USER_MANAGEMENT_ROLE';
Role.API_KEY_DEV_CONSOLE_ROLE = 'API_KEY_DEV_CONSOLE_ROLE';
Role.API_KEY_DEV_CONSOLE_READ_ROLE = 'API_KEY_DEV_CONSOLE_READ_ROLE';
Role.WEBHOOK_DEV_CONSOLE_ROLE = 'WEBHOOK_DEV_CONSOLE_ROLE';
Role.WEBHOOK_DEV_CONSOLE_READ_ROLE = 'WEBHOOK_DEV_CONSOLE_READ_ROLE';
Role.PW_DEV_CONSOLE_ROLE = 'PW_DEV_CONSOLE_ROLE';
Role.PW_DEV_CONSOLE_READ_ROLE = 'PW_DEV_CONSOLE_READ_ROLE';
Role.SCP_DEV_CONSOLE_ROLE = 'SCP_DEV_CONSOLE_ROLE';
Role.SCP_DEV_CONSOLE_READ_ROLE = 'SCP_DEV_CONSOLE_READ_ROLE';
Role.PGS_DEV_CONSOLE_ROLE = 'PGS_DEV_CONSOLE_ROLE';
Role.PGS_DEV_CONSOLE_READ_ROLE = 'PGS_DEV_CONSOLE_READ_ROLE';
Role.DEVELOPER_DEFAULT_ROLE = 'DEVELOPER_DEFAULT_ROLE';
Role.DEVELOPER_ADMIN_DEFAULT_ROLE = 'DEVELOPER_ADMIN_DEFAULT_ROLE';
Role.DEVELOPER_VIEWER_DEFAULT_ROLE = 'DEVELOPER_VIEWER_DEFAULT_ROLE';
// Checkout Session roles
Role.CHECKOUT_SESSION_ROLE = 'CHECKOUT_SESSION_ROLE';
Role.CHECKOUT_SESSION_READ_ROLE = 'CHECKOUT_SESSION_READ_ROLE';
Role.CHECKOUT_SESSION_MANAGEMENT_ROLE = 'CHECKOUT_SESSION_MANAGEMENT_ROLE';
// Payment roles
Role.PAYMENTS_ROLE = 'PAYMENTS_ROLE';
Role.PAYMENTS_READ_ROLE = 'PAYMENTS_READ_ROLE';
// Payment roles
Role.PAYOUTS_ROLE = 'PAYOUTS_ROLE';
Role.PAYOUTS_READ_ROLE = 'PAYOUTS_READ_ROLE';
// Address Book roles
Role.ADDRESS_BOOK_ROLE = 'UI_ADDRESS_BOOK_ROLE';
Role.ADDRESS_BOOK_READ_ROLE = 'UI_ADDRESS_BOOK_READ_ROLE';
Role.ADDRESS_BOOK_REMOVAL_ROLE = 'UI_ADDRESS_BOOK_REMOVAL_ROLE';
// Settlement Advance roles
Role.SETTLEMENT_ADVANCE_ROLE = 'UI_SETTLEMENT_CREDIT_ROLE';
Role.SETTLEMENT_ADVANCE_READ_ROLE = 'UI_SETTLEMENT_CREDIT_READ_ROLE';
// Convert/FX roles
Role.EXCHANGE_ROLE = 'EXCHANGE_ROLE';
// Bank account roles
Role.BANK_ACCOUNT_ROLE = 'UI_BANK_ACCOUNT_ROLE';
Role.BANK_ACCOUNT_READ_ROLE = 'UI_BANK_ACCOUNT_READ_ROLE';
// IP Allowlist roles
Role.IP_ALLOWLIST_ROLE = 'UI_IP_ALLOWLIST_ROLE';
Role.IP_ALLOWLIST_READ_ROLE = 'UI_IP_ALLOWLIST_READ_ROLE';
// Delayed Withdraw roles
Role.DELAYED_WITHDRAWAL_ROLE = 'UI_DELAYED_WITHDRAWAL_ROLE';
Role.DELAYED_WITHDRAWAL_READ_ROLE = 'UI_DELAYED_WITHDRAWAL_READ_ROLE';
// Fraud Management roles
Role.FRAUD_MANAGEMENT_ROLE = 'UI_FRAUD_MANAGEMENT_ROLE';
// Transaction Limit roles
Role.TRANSACTION_LIMIT_ROLE = 'UI_TRANSACTION_LIMIT_ROLE';
// Express roles
Role.STABLECOIN_EXPRESS_ROLE = 'STABLECOIN_EXPRESS_ROLE';
Role.STABLECOIN_EXPRESS_READ_ROLE = 'STABLECOIN_EXPRESS_READ_ROLE';
Role.STABLECOIN_EXPRESS_BURN_ROLE = 'UI_STABLECOIN_EXPRESS_BURN_ROLE';
Role.STABLECOIN_EXPRESS_BURN_READ_ROLE = 'UI_STABLECOIN_EXPRESS_BURN_READ_ROLE';
Role.STABLECOIN_EXPRESS_MINT_ROLE = 'UI_STABLECOIN_EXPRESS_MINT_ROLE';
Role.STABLECOIN_EXPRESS_MINT_READ_ROLE = 'UI_STABLECOIN_EXPRESS_MINT_READ_ROLE';
// User Management roles
Role.USER_MANAGEMENT_ROLE = 'USER_MANAGEMENT_ROLE';
Role.USER_MANAGEMENT_READ_ROLE = 'USER_MANAGEMENT_READ_ROLE';
Role.USER_MANAGEMENT_POLICY_ROLE = 'UI_USER_MANAGEMENT_POLICY_ROLE';
// ROLR redemption-only account roles
Role.ROLR_REDEMPTION_ONLY_ROLE = 'UI_ROLR_ROLE';
// Wires roles
Role.WIRES_ROLE = 'WIRES_ROLE';
Role.WIRES_READ_ROLE = 'WIRES_READ_ROLE';
Role.WIRES_DEPOSIT_ROLE = 'UI_WIRES_DEPOSIT_ROLE';
Role.WIRES_WITHDRAW_ROLE = 'UI_WIRES_WITHDRAWAL_ROLE';
// Onchain transaction roles
Role.ONCHAIN_DEPOSIT_ROLE = 'UI_ONCHAIN_DEPOSIT_ROLE';
Role.ONCHAIN_TRANSFER_ROLE = 'UI_ONCHAIN_TRANSFER_ROLE';
// Wallets roles
Role.WALLETS_ROLE = 'WALLETS_ROLE';
Role.WALLETS_READ_ROLE = 'WALLETS_READ_ROLE';
// Approval workflow roles
Role.MAIN_WALLET_POLICY_ROLE = 'UI_MAIN_WALLET_POLICY_ROLE';
Role.MAIN_WALLET_POLICY_READ_ROLE = 'UI_MAIN_WALLET_POLICY_READ_ROLE';
Role.PROPOSAL_MANAGEMENT_ROLE = 'UI_PROPOSAL_MANAGEMENT_ROLE';
// Proposals (activity center) roles
Role.ACTIVITY_CENTER_READ_ROLE = 'UI_ACTIVITY_CENTER_READ';
// Currency-specific roles
Role.USDC_WALLET_ROLE = 'UI_USDC_WALLET_ROLE';
Role.EURC_WALLET_ROLE = 'UI_EURC_WALLET_ROLE';
// TODO: Check if we can remove them as it seems like they are left overs
Role.HIDE_PAYOUT_TAB_ROLE = 'HIDE_PAYOUT_TAB_ROLE';
Role.HIDE_SETTLEMENT_TAB_ROLE = 'HIDE_SETTLEMENT_TAB_ROLE';
Role.REBALANCER_ROLE = 'REBALANCER_ROLE';
// Roles to determine users' API key entitlements
Role.CREATE_API_KEY_ROLE = 'UI_CREATE_API_KEY_ROLE';
Role.CROSS_CURRENCY_API_ROLE = 'UI_CROSS_CURRENCY_API_ROLE';
// Roles to determine account role
Role.CORPORATE_ACCOUNT_ROLE = 'UI_CORPORATE_ACCOUNT_ROLE';
Role.CUSTOMER_ACCOUNT_ROLE = 'UI_CUSTOMER_ACCOUNT_ROLE';
// Role for the burn fee history section
Role.BURN_FEE_HISTORY_ROLE = 'BURN_FEE_HISTORY_ROLE';
// This role represents authorized representative of an entity
Role.AUTHORIZED_REP_ROLE = 'AUTHORIZED_REP_ROLE';
/**
     * CPN Console Roles.
     */ // OFI Admin (user management, developer tools, onboarding)
Role.CPN_CONSOLE_OFI_ADMIN_ROLE = 'CPN_CONSOLE_OFI_ADMIN_ROLE';
// OFI Developer (developer tools)
Role.CPN_CONSOLE_OFI_DEVELOPER_ROLE = 'CPN_CONSOLE_OFI_DEVELOPER_ROLE';
// BFI Admin (user management, developer tools, onboarding)
Role.CPN_CONSOLE_BFI_ADMIN_ROLE = 'CPN_CONSOLE_BFI_ADMIN_ROLE';
// BFI Developer (developer tools)
Role.CPN_CONSOLE_BFI_DEVELOPER_ROLE = 'CPN_CONSOLE_BFI_DEVELOPER_ROLE';
// OFI Compliance Officer (Onboarding)
Role.CPN_CONSOLE_OFI_COMPLIANCE_OFFICER_ROLE = 'CPN_CONSOLE_OFI_COMPLIANCE_OFFICER_ROLE';
// BFI Compliance (Onboarding)
Role.CPN_CONSOLE_BFI_COMPLIANCE_OFFICER_ROLE = 'CPN_CONSOLE_BFI_COMPLIANCE_OFFICER_ROLE';

export { Role };
//# sourceMappingURL=index.js.map
